import { render, staticRenderFns } from "./mapTag.vue?vue&type=template&id=a8ff4a18&scoped=true&"
import script from "./mapTag.vue?vue&type=script&lang=js&"
export * from "./mapTag.vue?vue&type=script&lang=js&"
import style0 from "./mapTag.vue?vue&type=style&index=0&id=a8ff4a18&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a8ff4a18",
  null
  
)

export default component.exports